<template>
  <div>
    <table-filter v-model="filter" :columns="columns"/>
    <div class="row justify-between q-mt-sm">
      <div>
        <q-btn
          v-if="selectedRows.length"
          @click="tagsPickerOpened = true"
          color="primary"
          icon="local_offer"
          flat
          no-caps
          label="Теги"
        />
        <tags-picker
          v-model="tagsPickerOpened"
          @save="(addedTags, deletedTags) => updateTags(addedTags, deletedTags)"
          :attachedTags="tagsFromSelection"
        />
      </div>
      <q-table-columns
        color="secondary"
        class="q-mr-sm"
        v-model="visibleColumns"
        :columns="columns"
      />
    </div>
    <h-table
      :data="data"
      row-key="name"
      :columns="columns"
      :visible-columns="visibleColumns"
      :filter="filter"
      :pagination.sync="serverPagination"
      :rows-per-page-options="perPageOptions"
      selection="multiple"
      :selected.sync="selectedRows"
      :loading="loading"
      ref="table"
      @request="fetchData"

    >
      <q-td
        slot="body-cell-name"
        slot-scope="props"
      >
        <a :href="'/projects/' + props.row.id">{{props.value}}</a>
      </q-td>
      <q-td
        slot="body-cell-client"
        slot-scope="props"
      >
        <router-link :to="`users/${props.row.owner_id}`">{{props.value}}</router-link>
      </q-td>
      <q-td
        slot="body-cell-domain"
        slot-scope="props"
        :props="props"
      >
        <a
          v-if="props.value"
          :href="`http${props.value.ssl !== 'NONE' ? 's' : ''}://` + props.value.fqdn"
          target="_blank"
        >
          {{props.value.fqdn}}
        </a>
        <q-btn
          v-if="props.value"
          @click="this.window.open(`http${props.value.ssl !== 'NONE' ? 's' : ''}://` + props.value.fqdn + '/edit/', '_blank')"
          icon="vpn_key"
          flat
          round
          size="sm"
          color="primary"
        />
      </q-td>
      <q-td 
        slot="body-cell-tags"
        slot-scope="props"
        :props="props"
      >
        <q-chip 
          v-for="(tag, index) in props.value" 
          :key="index" 
          square 
          dense
          color="secondary"
          style="margin-right: 2px;"
        >
          {{ tag }}
        </q-chip>
      </q-td>
    </h-table>
  </div>
</template>

<script>
  import HTable from '@/HTable';
  import TagsPicker from '@/TagsPicker';
  import TableFilter from '@/TableFilter';
  import tableHelpers from '@/HTable/helpers';
  import api from 'mixins/api';
  import columns from './mixins/columns';
  import {
    QTable,
    QTableColumns,
    QTr,
    QTh,
    QTd,
    QField,
    QInput,
    QCheckbox,
    QSelect,
    QSlider,
    QBtn,
    QIcon,
    QTooltip,
    QPopover,
    QModal,
    QChip,
    QDatetimePicker,
    date
  } from 'quasar';
  import fetchServiceProviders from "../../mixins/fetchServiceProviders";

  export default {
    name: 'Projects',
    components: {
      QTable,
      QTableColumns,
      QTr,
      QTh,
      QTd,
      QField,
      QInput,
      QCheckbox,
      QSelect,
      QSlider,
      QBtn,
      QIcon,
      QTooltip,
      QPopover,
      QModal,
      QChip,
      QDatetimePicker,
      date,
      HTable,
      TagsPicker,
      TableFilter
    },
    mixins: [
      tableHelpers,
      api,
      columns,
      fetchServiceProviders,
    ],
    data () {
      return {
        visibleColumns: this.getVisibleColumns() || ['name', 'client', 'status', 'edit'],
        popperOffset: [0, 0],
        perPageOptions: [10, 50, 100, 200],
        tags: [],
        visibleTags: [],
        tagsPickerOpened: false,
        tagHovering: false,
        projectTags: []
      };
    },
    computed: {
      tagsFromSelection () {
        return this.selectedRows.map(row => row.tags)
          .reduce((acc, val) => acc.concat(val), [])
          .filter((value, index, self) => self.indexOf(value) === index);
      }
    },
    mounted () {
      this.fetchFiltersAvailableValues();
      this.fetchServiceProviders();

      this.fetchData({
        pagination: this.serverPagination,
        filter: this.filter
      });
    },
    methods: {
      fetchData ({pagination, filter}) {
        this.loading = true;
        this.query = this.getQuery(pagination, filter);
        this.api.get(`projects/${this.query}`).then((response) => {
          if (this.verifyResponse(response)) {
            this.updatePagination(pagination, response.data.total);
            this.updateData(response.data.projects);
            this.$store.commit('projectsList/setData', response.data);
          }
          this.loading = false;
        }).catch(error => {
          console.error(error);
          this.loading = false;
        });
      },
      fetchFiltersAvailableValues () {
        this.api.get(`tags`).then(response => {
          this.columns.find(obj => obj.field === 'tags').values = response.data.map(val => {
            return {
              label: val.name,
              value: val.name
            };
          });
        });
        this.api.get(`users?filter[role][]=root&filter[role][]=manager&perPage=60`).then(response => {
          this.columns.find(obj => obj.field === 'manager').values = response.data.users.map(val => {
            return {
              label: val.first_name + ' ' + val.last_name,
              value: val.id
            };
          });
        });
      },
      updateTags (addedTags, removedTags) {
        const projectsIds = this.selectedRows.map(row => row.id);
        let promises = [];

        if (addedTags.length) {
          this.selectedRows
            .forEach(row =>
              row.tags = row.tags.concat(addedTags.map(tag => tag.name))
            );
          promises.push(
            new Promise((resolve, reject) => {
              this.$http.post(`api/v1.0/projects/tags/attach`, {
                'tags': addedTags.map(tag => tag.id),
                'projects': projectsIds
              }).then(() => {
                resolve();
              }).catch(error => {
                reject(error);
              });
            })
          );
        }

        if (removedTags.length) {
          this.selectedRows
            .forEach(row =>
              row.tags = row.tags.filter(tag => removedTags.map(removedTag => removedTag.name).indexOf(tag) === -1)
            );
          promises.push(
            new Promise((resolve, reject) => {
              this.$http.post(`api/v1.0/projects/tags/detach`, {
                'tags': removedTags.map(tag => tag.id),
                'projects': projectsIds
              }).then(() => {
                resolve();
              }).catch(error => {
                reject(error);
              });
            })
          );
        }

        Promise
          .all(promises)
          .then(
            this.$q.notify({
              message: `Теги обновлены`,
              type: 'positive',
              position: 'bottom'
            })
          )
          .catch(error => {
            this.$q.notify({
              message: `Возникла ошибка при сохранении тегов`,
              type: 'negative',
              position: 'bottom'
            });
            console.error(error);
          });
      },
      getDomain (domains) {
        if (!domains) {
          return null;
        }

        domains = domains.filter(domain => domain.fqdn_status === 'ASSIGNED');

        let actualDomains = domains.filter(domain => domain.fqdn.indexOf('horoshop') === -1);
        if (actualDomains.length) {
          return _.orderBy(actualDomains, 'sort_order', 'asc')[0];
        } else if (domains.length) {
          return _.orderBy(domains, 'sort_order', 'asc')[0];
        } else {
          return null;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .site-buttons {
    display: inline-flex;
    visibility: hidden;
  }

  .q-table tr:hover {
    .site-buttons {
      visibility: visible;
    }
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectsList/ProjectsList.vue